import { getHost } from "@src/env";
import type { LoginFormData, Radio } from "@src/types";
import { useMutation } from "@tanstack/react-query";

import { useMeuPlayState } from "@src/states/meuplay";

import { parseJSON } from "@src/utils/json";
import { safeFetch } from "@src/utils/safeFetch";

export function useLoginMutation() {
  return useMutation<Radio, Error, LoginFormData>({
    mutationKey: ["login"],
    mutationFn: async ({ idRadio, cnpj, senha }) => {
      if (!idRadio || String(idRadio) === "undefined") {
        console.log("idRadio is undefined");
        return;
      }
      const headers: HeadersInit = { "Content-Type": "application/json" };
      if (cnpj && senha) {
        const encodedCredentials = btoa(`${cnpj}:${senha}`);
        headers["Authorization"] = `Basic ${encodedCredentials}`;
      }
      const host = getHost();
      const response = await safeFetch(
        "useLoginMutation",
        `${host}/api/radio/${idRadio}`,
        {
          method: "GET",
          headers,
        },
      );
      const data = await parseJSON("useLoginMutation", response);
      const loginMustBeAbsent = `O CNPJ e a senha precisam estar em branco para a rádio ${idRadio}`;
      if (!response.ok) {
        const messages: Record<string, string> = {
          data_not_found: `Rádio ${idRadio} não encontrada`,
          disabled_radio: `Rádio ${idRadio} inativa`,
          incorrect_login_or_password: "CNPJ e/ou senha incorretos",
          login_and_password_required: "Informe CNPJ e senha",
          unlinked_radio: "Rádio não vinculada ao login informado",
          login_must_be_absent: loginMustBeAbsent,
        };
        console.log("login error:", data.error);
        const message = messages[data.error] ?? "Erro desconhecido";
        throw new Error(message);
      }
      if (data && !data.require_cnpj && (cnpj || senha)) {
        console.log("login error: senha informada em rádio que não aceita CNPJ");
        throw new Error(loginMustBeAbsent);
      }
      useMeuPlayState.setState({ didPong: false });
      return data;
    },
    onError: console.log,
  });
}
